//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, getNoCatch } from '@api/request';
import { mdrlAPI } from '@api/modules/mdrl';
import pubPagination from '@/components/common/pubPagination';
import { mdtkAPI } from '@api/modules/mdtk';
export default {
  name: 'SmplEditBom',
  components: {
    pubPagination: pubPagination
  },
  data: function data() {
    return {
      tableData: [],
      searchForm: {},
      totalPage: 0,
      btn: {},
      loading: true,
      currentPage: 1,
      mdrlType: [{
        id: 1,
        label: '主材料'
      }, {
        id: 2,
        label: '辅材料'
      }, {
        id: 3,
        label: '其他'
      }],
      title: '提示：相同数据仅限导入一条',
      optnColorList: [],
      multiSelectData: []
    };
  },
  created: function created() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      this.getMdrlsList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multiSelectData = val;
    },
    // 获取材料信息
    getMdrlsList: function getMdrlsList() {
      var _this = this;

      var timeNewVal = this.helper.getTime(this.searchForm.timeValue);
      this.searchForm.start_time = timeNewVal.startTime;
      this.searchForm.end_time = timeNewVal.endTime;
      this.searchForm.page_no = this.currentPage;
      getNoCatch(mdtkAPI.getMdtks, this.searchForm).then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;
        _this.tableData = data.list;
        _this.totalPage = data.total;
        _this.btn = data.btn;
        setTimeout(function () {
          _this.loadFlag = false;
        }, 500);
      });
    },
    // 清空
    clear: function clear() {
      this.$refs.multiTable.clearSelection();
    },
    // 查询方法
    getMdrlsNow: function getMdrlsNow() {
      this.$refs.pubPagination.currentPage = 1;
      this.loading = true;
      this.currentPage = 1;
      this.getMdrlsList();
    },
    // 刷新
    getMdrlsNowO: function getMdrlsNowO() {
      this.$refs.pubPagination.currentPage = 1;
      this.loading = true;
      this.currentPage = 1;
      this.searchForm = {
        mdrl_no: null,
        mdrl_name: null,
        mdrl_type: null,
        mdrl_color: null,
        colr_class: []
      }, this.getMdrlsList();
    },
    // 分页查询
    changePageSearch: function changePageSearch(val) {
      this.currentPage = val;
      this.getMdrlsList();
    },
    formatPic: function formatPic(scope, type) {
      var updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
      return this.helper.picUrl(scope.row.imge_url, type, updateTime);
    },
    // 材料类型
    formatLeavType: function formatLeavType(row) {
      if (row.mdrl_type === 1) {
        return '主材料';
      } else if (row.mdrl_type === 2) {
        return '辅材料';
      } else {
        return '其他';
      }
    },
    formatMdtkStatus: function formatMdtkStatus(row) {
      if (row.mstk_status === 1) {
        return '库存充足';
      } else if (row.mstk_status === 2) {
        return '库存不足';
      }
    },
    // 取消选择
    cancel: function cancel() {
      this.$emit('mdrlChanel', false);
    },
    // 确认选择
    confirmIn: function confirmIn() {
      if (!this.multiSelectData) return this.$message.warning('请至少选择一条数据!');
      this.$emit('mdrlConfirm', this.multiSelectData);
    }
  }
};